import ICredentials from "./ICredentials";

export default class Credentials implements ICredentials {
    constructor(public username: string, public password: string) {}
}
